module.exports = __webpack_public_path__ + "static/media/right-arrow.05e068a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/right-arrow.svg
// module id = 52
// module chunks = 0